// extracted by mini-css-extract-plugin
module.exports =  {"authorizationButton":"authorizationButton___M1w2Y"};